// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BodyDiagramController from "./body_diagram_controller"
application.register("body-diagram", BodyDiagramController)

import BookingStep1Controller from "./booking_step1_controller"
application.register("booking-step1", BookingStep1Controller)

import BookingWizardController from "./booking_wizard_controller"
application.register("booking-wizard", BookingWizardController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DashboardBookingController from "./dashboard_booking_controller"
application.register("dashboard-booking", DashboardBookingController)

import FoSelectController from "./fo_select_controller"
application.register("fo-select", FoSelectController)

import FocalPointController from "./focal_point_controller"
application.register("focal-point", FocalPointController)

import GroupBookingController from "./group_booking_controller"
application.register("group-booking", GroupBookingController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HotelBookingController from "./hotel_booking_controller"
application.register("hotel-booking", HotelBookingController)

import LocationSwitchController from "./location_switch_controller"
application.register("location-switch", LocationSwitchController)

import NationalitySelectController from "./nationality_select_controller"
application.register("nationality-select", NationalitySelectController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PhoneFieldController from "./phone_field_controller"
application.register("phone-field", PhoneFieldController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PrebookedToggleController from "./prebooked_toggle_controller"
application.register("prebooked-toggle", PrebookedToggleController)

import PromoCodeController from "./promo_code_controller"
application.register("promo-code", PromoCodeController)

import PromoFormController from "./promo_form_controller"
application.register("promo-form", PromoFormController)

import QrToggleController from "./qr_toggle_controller"
application.register("qr-toggle", QrToggleController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import TableScrollController from "./table_scroll_controller"
application.register("table-scroll", TableScrollController)

import ToggleFieldsController from "./toggle_fields_controller"
application.register("toggle-fields", ToggleFieldsController)

import TreatmentPickerController from "./treatment_picker_controller"
application.register("treatment-picker", TreatmentPickerController)

import VisibilityRefreshController from "./visibility_refresh_controller"
application.register("visibility-refresh", VisibilityRefreshController)

import ZennaGuestController from "./zenna_guest_controller"
application.register("zenna-guest", ZennaGuestController)
